import React, { useState } from "react";
import { Box, Typography, Button, Alert, Stack } from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel
} from '@mui/material';

export default function StartAssessment({ assessmentInfo, onStart }) {
  const [fullscreenError, setFullscreenError] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleStartClick = () => {
    const elem = document.documentElement;

    if (elem.requestFullscreen) {
      elem
        .requestFullscreen()
        .then(() => {
          setFullscreenError(null);
          onStart();
        })
        .catch(() => {
          setFullscreenError(
            "Please allow fullscreen mode to start the assessment."
          );
        });
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
      onStart();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
      onStart();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
      onStart();
    } else {
      setFullscreenError("Fullscreen API is not supported by your browser.");
    }
  };

  const handleback=()=>
  {
     navigate('/course-assessment')
  }

   const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    if (checked) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  

  return (
    <Box
      maxWidth={600}
      margin="3rem auto"
      padding={4}
      boxShadow={3}
      borderRadius={2}
      bgcolor="background.paper"
      textAlign="center"
      fontFamily="'Roboto', 'Helvetica', 'Arial', sans-serif"
    >
      <Typography variant="h4" mb={3} color="text.primary" fontWeight={600} fontSize="1rem">
        {assessmentInfo.title}
      </Typography>

      <Stack spacing={1} alignItems="center" mb={3}>
        <Typography fontSize="1rem">
          <strong>Assessment Code:</strong> {assessmentInfo.code}
        </Typography>
        <Typography fontSize="1rem"> 
          <strong>Course:</strong> {assessmentInfo.course}
        </Typography>
        <Typography fontSize="1rem">
          <strong>Start Date:</strong>{" "}
          {new Date(assessmentInfo.startDate).toLocaleDateString()}
        </Typography>
        <Typography fontSize="1rem">
          <strong>End Date:</strong>{" "}
          {new Date(assessmentInfo.endDate).toLocaleDateString()}
        </Typography>
        <Typography fontSize="1rem">
          <strong>Pass Percentage:</strong> {assessmentInfo.passPercentage}%
        </Typography>
        <Typography fontSize="1rem">
          <strong>Time Limit:</strong>{" "}
          {Math.floor(assessmentInfo.timeLimitSeconds / 60)} minutes
        </Typography>
      </Stack>

      {fullscreenError && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {fullscreenError}
        </Alert>
      )}
       <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={handleCheckboxChange}
            name="agreeCheckbox"
          />
        }
        label="I agree to the terms and conditions"
      />

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Assessment Instructions</DialogTitle>
        <DialogContent>
          <p>
            Thank you for agreeing. Please read the following instructions
            carefully before starting the assessment.
          </p>
          <ul style={{marginLeft:'4%'}}>
            <li>Do not refresh the page during the test.</li>
            <li>Complete the test honestly and without assistance.</li>
            <li>Ensure a stable internet connection.</li>
          </ul>
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleClose} variant="gradient"
        color="dark"
        size="small">
            Proceed
          </MaterialButton>
        </DialogActions>
      </Dialog>
    </div>
      <div style={{display:'flex',justifyContent:'space-between'}}>
         <MaterialButton
              variant="gradient"
        color="dark"
        size="small"
        onClick={handleback}
        sx={{
          fontWeight: 700,
          px: 5,
          py: 1.5,}}>
          Cancel

      </MaterialButton>
      <MaterialButton
        variant="gradient"
        color="dark"
        size="small"
        onClick={handleStartClick}
        disabled={!isChecked}
        sx={{
          fontWeight: 700,
          px: 5,
          py: 1.5,
          // boxShadow: "0 6px 15px rgba(25,118,210,0.5)",
          // "&:hover": {
          //   backgroundColor: "primary.dark",
          //   boxShadow: "0 8px 20px rgba(21,101,192,0.7)",
          // },
        }}
      >
        Start Assessment
      </MaterialButton>
     
      </div>

      


    </Box>
  );
}
